import { render, staticRenderFns } from "./Airklima.vue?vue&type=template&id=6e94162c&scoped=true&"
import script from "./Airklima.vue?vue&type=script&lang=js&"
export * from "./Airklima.vue?vue&type=script&lang=js&"
import style0 from "./Airklima.vue?vue&type=style&index=0&id=6e94162c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e94162c",
  null
  
)

export default component.exports